import { render, staticRenderFns } from "./ExternalSignature.vue?vue&type=template&id=38ee64dc&"
import script from "./ExternalSignature.vue?vue&type=script&lang=js&"
export * from "./ExternalSignature.vue?vue&type=script&lang=js&"
import style0 from "./ExternalSignature.vue?vue&type=style&index=0&id=38ee64dc&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports